import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-wsapi',
    templateUrl: './wsapi.component.html',
    styleUrls: ['./wsapi.component.scss'],
    standalone: false
})
export class WSAPIComponent {

     userProfile: UserProfile | undefined;
     companyType: string = "";
     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService, private router: Router) {


          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;

          if (!this.userProfile!.customerId || this.userProfile!.customerId === '2147483647' || !this.userProfile!.customer) {
               this.router.navigate(['accessDenied']);
          }

          this.companyType = this.userProfile.customer.customerType === 1 ?
               'MC' :
               this.userProfile.customer.customerType === 6 ?
                    'ISP' :
                    '';

          this.scrollToTop();
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     updateUrl(url: string) {
          url = url.replace(`##docBaseUrl##`, `${environment.APP_PSP_DOC_BASE_URL}`)
               .replace(`##baseUrl##`, `${environment.APP_PSP_BASE_URL}`);
          return url;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
